import { NgModule } from '@angular/core';

import { BlobToSafeUrlPipe } from './blob-to-safe-url.pipe';

@NgModule({
  declarations: [BlobToSafeUrlPipe],
  exports: [BlobToSafeUrlPipe],
  providers: [BlobToSafeUrlPipe],
})
export class BlobToSafeUrl {}
